import { ReactElement } from 'react';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';
import { colors, theme } from '../../theme';

const color = colors();
const themes = theme().typography;

export const TraceabilityOverview = (): ReactElement => {
	const classes = useStyles();

	return (
		<div className={classes.container}>
			<Typography style={{ ...themes.bodyMedium, color: color.neutral[8] }}>Traceability Overview</Typography>
		</div>
	);
};

const useStyles = makeStyles(() => ({
	container: {
		paddingTop: '16px',
	},
}));
